import { ReferenceArea } from 'recharts';

// @ts-ignore
ReferenceArea.defaultProps.fillOpacity = '0.2';
// @ts-ignore
ReferenceArea.defaultProps.fill = 'url(#diagonalGradient)';

export { ReferenceArea };
